
















































































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import { PartSaleDetail } from '@/models/fixedops/partsales';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { FileHelper as _file } from '@/helper/file.helper';
import { Utils } from '@/helper/utils';
import { paymentService } from '@/shared';
import { IPaymentDialog } from '@/models/paymentDialog';

@Component({
  computed: {
    totalSalesTax: {
      get() 
      {
        if (
          this.partSaleDetail &&
          this.partSaleDetail.partsSalesJson &&
          this.partSaleDetail.partsSalesJson.details
        ) {
          let totalSaleTaxAmount = 0;
          let totalItemAmount = 0;
          this.partSaleDetail.partsSalesJson.details.forEach((detail) => {
            totalItemAmount += this.calculateAmount(
              detail.quantity,
              detail.netPrice
            );
          });
          if(!isNaN(Number(this.partSaleDetail.partsSalesJson.specialOrderDeposit)) && Number(this.partSaleDetail.partsSalesJson.specialOrderDeposit) > 0){
            totalSaleTaxAmount = Number(this.partSaleDetail.partsSalesJson.specialOrderDeposit) - totalItemAmount ;
          }else{
             const totalTax = Number(this.partSaleDetail.partsSalesJson.taxTotal);
             totalSaleTaxAmount = isNaN(totalTax) ? 0 : totalTax;
          }
          return totalSaleTaxAmount.toFixed(2);
        }
      },
    },
    sumTotalLineAmount: {
      get() {
        if (
          this.partSaleDetail &&
          this.partSaleDetail.partsSalesJson &&
          this.partSaleDetail.partsSalesJson.details
        ) {
          let totalAmount = 0;
          this.partSaleDetail.partsSalesJson.details.forEach((detail) => {
            totalAmount += this.calculateAmount(
              detail.quantity,
              detail.netPrice
            );
          });
          totalAmount += this.sumTotalAmountWithoutParts();
          return totalAmount.toFixed(2);
        }
      },
    },
    partSalesDetailValue: {
      get() {
        if (
          this.partSaleDetail.partsSalesJson &&
          this.partSaleDetail.partsSalesJson.details
        ) {
          return this.partSaleDetail.partsSalesJson.details;
        }
      },
    },
  },

  components: {
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    CenposPayment: () => import('@/components/common/cenpos.payment.vue'),
    SquarePayment: () => import('@/components/common/square.payment.vue'),
    CloverPayment: () => import('@/components/common/clover.payment.vue'),
    PaymentDialog: () => import('@/components/common/payment.dialog.vue')
  },
})
export default class PartSalePaymentPage extends Base {
  public paymentDialog: boolean = false;
  public partSaleDetail: any = {};
  public invoiceNumber: string = '';
  public transactionHeaderId: string = '';
  public paymentDetailId: string = '';
  public paymentApproved: boolean = false;
  public manualPaymentPopup: IDialogOption = {
    width: 400,
    title: this.$parent.$t('partSalesCpay.manualPaymentDialog.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t(
        'partSalesCpay.manualPaymentDialog.agree'
      ) as string,
      disable: false,
    },
    onAction: (): void => {
      this.payManually();
    },
  };
  public isLoaded: boolean = false;
  public loading: boolean = false;
  public cenposDialog: boolean = false;
  public cenposConfirmDialog: boolean = false;
  public isCloverDialog: boolean = false;
  public cenposStatus: boolean = false;
  public currentUrl: string = '';
  public storeName: string = '';
  public provider: string = '';
  public storeId: number = 0;
  public amountToBePaid: string = '';
  public isCenposConfigured: boolean = false;
  public isSquareConfigured: boolean = false;
  public isCloverConfigured: boolean = false;
  public squareDialog: boolean = false;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public loggedInUserEmail: string = '';
  public loggedInUserId: string = '';
  public amountWithServiceCharges: string = '';
  public firstName: string = '';
  public lastName: string = '';

  public mounted(): void {

    this.$watch(
      "partSaleDetail",
      (newVal) => {
        this.paymentOptions.address = newVal.customer ? newVal.customer.address1 : "";
        this.paymentOptions.city = newVal.customer ? newVal.customer.city : "";
        this.paymentOptions.state = newVal.customer ? newVal.customer.state : "";
        this.paymentOptions.zipcode = newVal.customer ? newVal.customer.zipCode : "";
        this.paymentOptions.phoneNumber = newVal.customer ? newVal.customer.homePhone : "";
        this.paymentOptions.customerEmail = newVal.customer ? newVal.customer.email : "";
        this.paymentOptions.merchantEmail = newVal.customer ? newVal.customer.email2 : "";
        this.paymentOptions.customerKey = newVal.customer ? newVal.customer.customerKey : "";
        this.paymentOptions.isOverrideCCFeeApplied = newVal.isOverrideCCFeeApplied;
        this.paymentOptions.bypassReason = newVal.bypassReason;
        this.paymentOptions.amountWithServiceCharges = newVal.amountWithServiceCharges;
      },
      {
        deep: true,
      }
    );

    this.$watch("amountToBePaid", (newVal) => {
      this.paymentOptions.amount = Number(newVal);
    });

    this.$watch("invoiceNumber", (newVal) => {
      this.paymentOptions.recordKey = newVal;
    });

    this.$watch("transactionHeaderId", (newVal) => {
      this.paymentOptions.transactionHeaderId = newVal;
    });

    this.$watch("paymentDetailId", (newVal) => {
      this.paymentOptions.lastPaymentDetailId = newVal;
    });

    this.$watch("storeId", (newVal) => {
      this.paymentOptions.storeId = newVal;
    });
    this.$watch("firstName", (newVal) => {
      this.paymentOptions.firstName = newVal;
    });
    this.$watch("lastName", (newVal) => {
      this.paymentOptions.lastName = newVal;
    });

    if (this.$route.params.invoiceNumber) {
      this.invoiceNumber = this.$route.params.invoiceNumber;
      this.transactionHeaderId = this.$route.params.txId;
      this.paymentDetailId = this.$route.params.detailId;
      this.getPartSaleDetail();
    }

    this.currentUrl = window.location.href;
  }

  public updateCenposDialog(cenposDialogVaue) {
    this.cenposDialog = cenposDialogVaue;
  }

  public updateSquareDialog(squareDialogValue) {
    this.squareDialog = squareDialogValue;
  }

  public async getPartSaleDetail(): Promise<void> {
    try {
      this.loading = true;
      const response = await paymentService.getPartSaleDetails(
        this.invoiceNumber,
        this.transactionHeaderId,
        this.paymentDetailId
      );
      this.partSaleDetail = response;
      this.tenantId = this.userSession.tenantId;
      this.enterpriseId = this.userSession.enterpriseId;
      this.loggedInUserEmail = this.userSession.email;
      this.loggedInUserId = this.userSession.sessionUserId;
      this.storeName = this.partSaleDetail.store.name;
      this.provider = this.partSaleDetail.store.provider;
      this.storeId = this.partSaleDetail.store.storeId;
      this.amountToBePaid = this.partSaleDetail.displayDueAmount;
      this.isCenposConfigured = this.partSaleDetail.store.isCenposConfigured;
      this.isSquareConfigured = this.partSaleDetail.store.isSquareConfigured;
      this.isCloverConfigured = this.partSaleDetail.store.isCloverConfigured;
      this.amountWithServiceCharges = this.partSaleDetail.amountWithServiceCharges;
      this.firstName = this.partSaleDetail.customer ? this.partSaleDetail.customer.name : '';

      if (
        this.partSaleDetail.paymentDetail &&
        this.partSaleDetail.paymentDetail.status === 'Approved'
      ) {
        this.paymentApproved = true;
      }

      if (
        this.partSaleDetail.paymentDetail &&
        this.partSaleDetail.paymentDetail.paymentResponses &&
        this.partSaleDetail.paymentDetail.paymentResponses.length > 0
      ) {
        const approvedPayment = this.partSaleDetail.paymentDetail.paymentResponses.find(
          (pay) => {
            return pay.status === 'Approved' && pay.id == this.paymentDetailId;
          }
        );
        if (approvedPayment && approvedPayment.status === 'Approved') {
          // approvedPayment
          this.paymentApproved = true;
        }

        // if (this.roDetails.paymentDetail.status === 'Approved') {
        //   // approvedPayment
        //   this.flags.paymentApproved = true;
        // }
      }
    } finally {
      this.loading = false;
    }
  }

  public async payManually(): Promise<void> {
    if (
      Number(this.partSaleDetail.displayDueAmount) === 0 ||
      isNaN(Number(this.partSaleDetail.displayDueAmount))
    ) {
      this.showAlert(false, this.$t('partSalesCpay.alertDueAmount'));
      return;
    }

    try {
      this.manualPaymentPopup.loading = true;
      const response = await paymentService.customerSalePartPayment(
        this.invoiceNumber,
        this.transactionHeaderId,
        this.paymentDetailId,
        this.partSaleDetail.displayDueAmount
      );
      if (response.redirectUri) {
        location.href = response.redirectUri.toString();
      }
    } finally {
      this.manualPaymentPopup.loading = false;
      this.manualPaymentPopup.model = false;
    }
  }

  public calculateAmount(quantity: string, netPrice: string) {
    const qty = Number(quantity);
    const price = Number(netPrice);
    if (!isNaN(qty) && !isNaN(price)) {
      return price * qty;
    }
    return 0;
  }

  public async confirmPay(): Promise<void> {
    if (this.provider == 'Vantiv') {
      this.manualPaymentPopup.model = true;
    } else {
      this.paymentDialog = true;
      this.$root.$emit('validatePaymentProvider');
    }
  }

  public updateCloverDialog(cloverDialogVaue) {
    this.isCloverDialog = cloverDialogVaue;
  }

  public async ValidationCenpos(): Promise<void> {
    if (this.provider == 'Cenpos') {
      const validateMessage = this.validateCenpos();
      if (validateMessage == '') {
        this.cenposConfirmDialog = false;
        this.cenposDialog = true;
      } else {
        const message =
          'Can not Make the payment because, Customer' +
          validateMessage +
          ' are Empty.';
        this.showAlert(false, message);
      }
    } else if (this.provider == 'Square') {
      this.cenposConfirmDialog = false;
      this.squareDialog = true;
    }
  }

  public validateCenpos(): string {
    let message = '';
    if (
      this.partSaleDetail.customer.city == undefined ||
      this.partSaleDetail.customer.city == ''
    ) {
      message += ' City';
    }
    if (
      this.partSaleDetail.customer.customerKey == undefined ||
      this.partSaleDetail.customer.customerKey == ''
    ) {
      message += ' CustomerKey';
    }

    if (
      this.partSaleDetail.customer.state == undefined ||
      this.partSaleDetail.customer.state == ''
    ) {
      message += ' State';
    }

    if (
      this.partSaleDetail.customer.address1 == undefined &&
      this.partSaleDetail.customer.address1 == ''
    ) {
      message += ' Address';
    }

    return message;
  }

  public sumTotalAmount() {
    const shipping = isNaN(
      Number(this.partSaleDetail.partsSalesJson.shippingTotal)
    )
      ? 0
      : Number(this.partSaleDetail.partsSalesJson.shippingTotal);
    const tax = isNaN(Number(this.partSaleDetail.partsSalesJson.taxTotal))
      ? 0
      : Number(this.partSaleDetail.partsSalesJson.taxTotal);
    const specialOrderDeposit = isNaN(
      Number(this.partSaleDetail.partsSalesJson.specialOrderDeposit)
    )
      ? 0
      : Number(this.partSaleDetail.partsSalesJson.specialOrderDeposit);
    const total =
      Number(this.partSaleDetail.partsSalesJson.partsTotal) +
      shipping +
      tax +
      specialOrderDeposit;
    return total.toFixed(2);
  }

  public sumTotalAmountWithoutParts() {
    const shipping = isNaN(
      Number(this.partSaleDetail.partsSalesJson.shippingTotal)
    )
      ? 0
      : Number(this.partSaleDetail.partsSalesJson.shippingTotal);
     let totalSaleTaxAmount = 0;
        if (
          this.partSaleDetail &&
          this.partSaleDetail.partsSalesJson &&
          this.partSaleDetail.partsSalesJson.details
        ) {
         
          let totalItemAmount = 0;
          this.partSaleDetail.partsSalesJson.details.forEach((detail) => {
            totalItemAmount += this.calculateAmount(
              detail.quantity,
              detail.netPrice
            );
          });
           if(!isNaN(Number(this.partSaleDetail.partsSalesJson.specialOrderDeposit)) && Number(this.partSaleDetail.partsSalesJson.specialOrderDeposit) > 0){
            totalSaleTaxAmount = Number(this.partSaleDetail.partsSalesJson.specialOrderDeposit) - totalItemAmount ;
          }else {
              const totalTax = Number(this.partSaleDetail.partsSalesJson.taxTotal);
             totalSaleTaxAmount = isNaN(totalTax) ? 0 : totalTax;
          }
        }
    const total = shipping + totalSaleTaxAmount;
    return total;
  }

  public paymentOptions: IPaymentDialog = {
    id: "PartSalePaymentAnonymous",
    url: window.location.href,
    amount: Number(this.amountToBePaid),
    recordKey: this.invoiceNumber,
    transactionHeaderId: this.transactionHeaderId,
    lastPaymentDetailId: this.paymentDetailId,
    address: "",
    city: "",
    state: "",
    zipcode: "",
    phoneNumber: "",
    customerEmail: "",
    merchantEmail: "",
    recordIdentifier: "PartSale",
    type: "0",
    customerKey: "",
    isOverrideCCFeeApplied: this.partSaleDetail.isOverrideCCFeeApplied,
    bypassReason: this.partSaleDetail.bypassReason,
    storeId: this.storeId,
    amountWithServiceCharges: this.partSaleDetail.amountWithServiceCharges,
    firstName: this.firstName,
    lastName: this.lastName
  };
  public updatePaymentDialog(paymentDialogValue) {
    this.paymentDialog = paymentDialogValue;
  }
}
